import { NgModule } from '@angular/core';
import { AvanoMoreLessInformationComponent } from './avano-more-less-information.component';

@NgModule({
  declarations: [AvanoMoreLessInformationComponent],
  exports: [AvanoMoreLessInformationComponent]
})
export class AvanoMoreLessInformationModule { }
